import Header from 'components/VerticalLayout/Header'
import React from 'react'
import { Container,Card,Row,Col } from 'reactstrap'
import bgImage from "../../../../assets/images/bgImage1.jpg";
import { PiUsersDuotone } from 'react-icons/pi';
import { GiCash } from "react-icons/gi";
import IconCardButton from 'pages/Dboard/IconCardButton ';
import { useNavigate } from 'react-router-dom';

const UsersPage = () => {
    const navigate = useNavigate();

  return (
    <div className='account'>
        <Header/>
        <div className='accountbg'
            style={{
                background: `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment:"fixed",
                paddingTop:"80px",
                minHeight:"100vh",
                overflowX:"auto",
                paddingLeft:"8px"
                }}
        >
           <Container fluid className='py-2' style={{paddingLeft:"20px",paddingRight:"20px"}}>
                <Card style={{height:"100vh"}} className='align-items-center justify-content-center'>
                    <Row>
                        <Col xs="auto">
                            <IconCardButton icon={PiUsersDuotone} title="User Administration" onClick={()=> navigate('/userlist')}/>
                        </Col>
                        <Col xs="auto">
                            <IconCardButton icon={GiCash} title="Credit Management" onClick={()=> navigate('/user-credit-management')}/>
                        </Col>
                    </Row>
                </Card>
           </Container>
        </div>
    </div>
  )
}

export default UsersPage
